// removed by extract-text-webpack-plugin
module.exports = {"root":"styles__root__3aKGu","modalContent":"styles__modalContent__2i3I-","modalTitle":"styles__modalTitle__2dLAk","modalMessage":"styles__modalMessage__1jh9A","modalButtonOk":"styles__modalButtonOk__2WfAy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CancelBookingModal/styles.css
// module id = 1621
// module chunks = 0